import { z } from 'zod';

import { InstanceIdType } from '#core/schema/defs.ts';

export const CogniteFileModel = z.object({
  ...InstanceIdType.shape,

  name: z.string().optional(),
  tags: z.string().array().optional(),
  assets: InstanceIdType.array().optional(),
  mimeType: z.string().optional(),
  directory: z.string().optional(),
  isUploaded: z.boolean().optional(),
  uploadedTime: z.coerce.date().optional(),
  sourceContext: z.string().optional(),
});

/** @public */
export type CogniteFileModelInput = z.input<typeof CogniteFileModel>;
/** @public */
export type CogniteFileModelOutput = z.output<typeof CogniteFileModel>;
